<template>
  <div class="w-full xl:max-w-209">
    <div class="flex w-full p-3 mb-8 bg-white border border-gray-300">
      <div class="flex-shrink-0 w-8 xl:w-10">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" v-if="variant === 'warning'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19.25 0H1.75A1.75 1.75 0 000 1.75v17.5A1.75 1.75 0 001.75 21h17.5A1.75 1.75 0 0021 19.25V1.75A1.75 1.75 0 0019.25 0zm-7 17.063h-3.5V8.9h3.5zM10.5 7.438a1.75 1.75 0 111.75-1.75 1.75 1.75 0 01-1.75 1.75z" fill="#999"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12.6 0H5.269L0 5.4v7.2L5.4 18h7.2l5.4-5.4V5.4zm1.665 12.189l-2.121 2.121-3.189-3.19-3.189 3.19-2.122-2.121L6.837 9l-3.19-3.189 2.122-2.122 3.189 3.19 3.189-3.19 2.121 2.122L11.08 9z" fill="#c00"/></svg>
      </div>
      <div>
        <p class="pb-2 font-bold leading-tight xl:text-lg font-lufthansa-head">
          {{ title }}
        </p>
        <p class="text-sm">
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '~brand-components/base/alert/alert'

export default Alert.extend()
</script>
